import React from "react";
import CountryListTable from "./CountryList";
import { useHistory } from "react-router-dom";
import BreadcrumbIndex from "../../breadcrumb/BreadcrumbIndex";

export default function Country(props) {
  const tableheader = [
    { name: "Country name", key: "title", type: "text" },
    { name: "Default city for new user", key: "default_city", type: "text" },
    { name: "Default area for new user", key: "default_area", type: "text" },
    { name: "Holiday", key: "holiday", type: "day" },
    { name: "Cut-off Time", key: "cut_off_time", type: "timer" },
    { name: "Action", key: "enabled", type: "switch" },
  ];

  const cretetableheader = [
    { name: "Title", key: "title", type: "text" },
    //{ name: "Name En", key: "name_en", type: "text" },
    //{ name: "Name Ar", key: "name_ar", type: "text" },
    //{ name: "COD", key: "cod", type: "text" },
    //{ name: "Enabled", key: "enabled", type: "switch" },
  ];

  /*   const [state, setState] = useState({
    title: "New Country",
    name_en: "",
    name_ar: "",
    enabled: true,
    cod: "",
    countryList: [],
  });
 */
  /*   const createCountry = (e) => {
    e.preventDefault();
    console.log(state);
  };

  const changeFieldValue = (event) => {
    if (event.target.type === "checkbox") {
      setState({ ...state, [event.target.name]: event.target.checked });
    } else {
      setState({ ...state, [event.target.name]: event.target.value });
    }
  }; */
  /*   const addNewCountry = () => {
    if (props.openAddCountryModal) {
      return (
        <ManageItem
          open={props.openAddCountryModal}
          close={props.closeAddCountryModal}
          metadata={cretetableheader}
          data={state}
          actionHandler={createCountry}
          changeFieldValue={changeFieldValue}
        />
      );
    }
  }; */

  const history = useHistory();
  const breadcrumb = [{ title: "Home", url: "/mapper/country" }];
  localStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));

  const onSelectedCountry = (selectedCountry) => {
    localStorage.setItem("country", selectedCountry.title);
    history.push("/mapper/province");
  };

  return (
    <div>
      <BreadcrumbIndex />
      <CountryListTable
        tableheader={tableheader}
        tabaledata={props.countryList}
        rowSelected={onSelectedCountry}
        cretetableheaderMeta={cretetableheader}
        changeLogs={props.changeLogs}
        hasChanges={props.hasChanges}
      />

      {/* {addNewCountry()} */}
    </div>
  );
}
